import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import ComponentWrapper from "../ComponentWrapper/ComponentWrapper.js";
import Banner from "../Banner/Banner.js";
const Template = styled("div")(() => ({
  width: "100%"
}));
const BannerTemplate = (t0) => {
  const $ = c(5);
  const {
    banner,
    isLoading: t1
  } = t0;
  const isLoading = t1 === void 0 ? false : t1;
  let t2;
  if ($[0] !== banner || $[1] !== isLoading) {
    t2 = banner && /* @__PURE__ */ jsx(ComponentWrapper, { className: "card-header", children: /* @__PURE__ */ jsx(Banner, { ...banner, isLoading }) }, "banner");
    $[0] = banner;
    $[1] = isLoading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = /* @__PURE__ */ jsx(Template, { children: t2 });
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export {
  BannerTemplate as default
};
